import { Box, Typography } from "@mui/material";
import styled from "styled-components";
import PieCharts from "../../Charts/PieChart";
import { HitsArr } from "../../../types/types";
import { useTranslation } from "react-i18next";

type Props = {
  filteredData: HitsArr[];
};

const FirstGroup = ({ filteredData }: Props) => {
  const dataLength = filteredData?.length;

  const { t } = useTranslation();

  const solutionStatusFalse = filteredData?.filter(
    (data) => data?._source.solution_status === false
  )?.length;

  const solutionStatusTrue = filteredData?.filter(
    (data) => data?._source.solution_status === true
  )?.length;

  const dataPie = [
    { name: "True", value: solutionStatusTrue },
    { name: "False", value: solutionStatusFalse },
  ];

  return (
    <FirstCharts>
      <Box
        height="300px"
        marginBottom="12px"
        display="flex"
        justifyContent="space-evenly"
        alignItems="center"
        flexDirection="column"
      >
        {dataPie[0]?.value ? (
          <PieCharts data={dataPie} />
        ) : (
          <p>{t("analyticResultMessage")}</p>
        )}
        <Typography variant="h6" textAlign="center">
          Solution Status
        </Typography>
      </Box>
      <Box
        height="300px"
        marginBottom="12px"
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
      >
        <Counter>{dataLength}</Counter>
        <p style={{ textAlign: "center", fontSize: "24px" }}>Count</p>
      </Box>
    </FirstCharts>
  );
};

export default FirstGroup;

const FirstCharts = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr ;
  grid-template-rows: 1fr;
  grid-column-gap: 10px;

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 1fr 1fr;
  }
`;
const Counter = styled.p`
  font-weight: bold;
  font-size: 80px;
`;
